<template>
  <div>
    <Notifications />
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
const defaultLayout = "public-layout";
import PublicLayout from "./layouts/PublicLayout.vue";
import InsurerLayout from "./layouts/InsurerLayout.vue";
import { Notifications } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    PublicLayout,
    InsurerLayout,
    Notifications,
  },
  computed: {
    layout() {
      return this.$route.meta.layout || defaultLayout;
    },
  },
  mounted() {
    this.clearAll();
  },
  methods: {
    ...mapActions("notifications", ["clearAll"]),
  },
};
</script>
